import { Formik, Form } from 'formik'

import { UpdateTranslationFormInner } from './update-translation-form-inner.component'
import { useUpdateTranslation } from 'src/hooks'
import { ITranslationForm, ITranslationWithDefault } from 'src/types'

import { translationSchema } from 'src/common/validations'
import { DEFAULT_LANGUAGE_CODE } from '../constants'

interface IProps {
  initialValues: ITranslationWithDefault
  handleClose: () => void
  lng: string
}

const UpdateTranslationForm = ({ initialValues, handleClose, lng }: IProps) => {
  const { mutateAsync: updateTranslation } = useUpdateTranslation()
  const isDefaultLng = initialValues.language.code === DEFAULT_LANGUAGE_CODE
  const handleSubmit = async (values: ITranslationForm) => {    
    const resp = await updateTranslation({
      value: values.value,
      translationId: initialValues.id,
      ai_translation: isDefaultLng ? null : values.ai_translation,
      review_required: values.review_required,
      helper_text: values.helper_text,
      ai_translation_helper: isDefaultLng ?  null : values.ai_translation_helper
    })

    if (!resp) return

    handleClose()
  }

  return (
    <>
      <Formik
        initialValues={{
          helper_text: initialValues.helper_text || '',
          namespace: initialValues.namespace,
          value: initialValues.value || '',
          ai_translation: initialValues.ai_translation || '',
          default_translation: initialValues.default?.value || null,
          review_required: initialValues.review_required,
          ai_translation_helper: initialValues.ai_translation_helper || '',
          default_translation_helper: initialValues.default?.helper_text || null
        }}
        validationSchema={translationSchema}
        onSubmit={handleSubmit}
      >
        <Form>
          <UpdateTranslationFormInner
            isDefaultLng={isDefaultLng}
            translationId={initialValues.id}
          />
        </Form>
      </Formik>
    </>
  )
}

export { UpdateTranslationForm }
